import useMount from '@src/utils/hooks/use-mount';
import { observable } from 'mobx';
import { useRef } from 'react';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';

class NegativeSectionStore {
  constructor(props = {}) {
    Object.assign(this, { ...props });
  }

  @observable isActive = false;

  src = IS_MASTER_ENV
    ? `https://mechabreak.seasungames.com/p/zt/2024/12/05/pre-dlc/${getLanguageByPath()}/#/`
    : `https://test-zt.xoyo.games/mechabreak.seasungames.com/p/zt/2024/12/05/pre-dlc/${getLanguageByPath()}/#/`;

  // src = 'http://127.0.0.1:5000/iframe-pc'; // 本地调试

  negativeIframeRef = null;
  onWheel = e => {
    const iframeWin = this.negativeIframeRef.current?.contentWindow;
    const iframeDocument = iframeWin?.document;
    if (iframeDocument?.querySelectorAll('[class*=openModal]').length || iframeDocument?.querySelectorAll('[class*=PhotoView-Portal]').length) {
      return;
    }
    this.pageSwiperStore?.onScroll(e);
  };
  onIframeLoad = () => {
    const iframeWin = this.negativeIframeRef.current?.contentWindow;
    const iframeDocument = iframeWin?.document;
    if (iframeDocument) {
      iframeDocument.addEventListener('wheel', this.onWheel);
    }
  };

  use() {
    this.negativeIframeRef = useRef(null);
    useMount(() => {
      return () => {
        const iframeDocument = this.negativeIframeRef.current?.contentDocument;
        if (iframeDocument) {
          iframeDocument.removeEventListener('wheel', this.onWheel);
        }
      };
    });
  }
}

export default NegativeSectionStore;
